import React from 'react';

interface SpinnerProps {
    text?: string;
    progress?: {
        current: number;
        total: number;
        fileProgress?: number;
        fileName?: string;
    };
    inline?: boolean;
}

export const Spinner: React.FC<SpinnerProps> = ({ text, progress, inline = false }) => {
    const spinnerClasses = inline ? "h-5 w-5 border-2 border-b-transparent" : "h-12 w-12 border-b-2";
    const textClasses = inline ? "text-sm" : "";
    
    if (inline) {
        return (
             <div className="flex items-center justify-center space-x-2">
                <div className={`animate-spin rounded-full border-current ${spinnerClasses}`}></div>
                {text && <span className={textClasses}>{text}</span>}
            </div>
        )
    }

    return (
        <div className="flex flex-col items-center justify-center space-y-2">
            <div className={`animate-spin rounded-full border-blue-500 ${spinnerClasses}`}></div>
            {(text || progress) && (
                 <div className="text-center">
                    <p className={`text-blue-500 font-semibold ${textClasses}`}>
                        {text ?? "Zpracovávám..."}
                        {progress && ` (soubor ${progress.current} / ${progress.total})`}
                    </p>
                    {progress?.fileName && (
                         <p className="text-sm text-gray-600 mt-1">
                            {progress.fileName}
                            {progress.fileProgress !== undefined && ` - ${Math.round(progress.fileProgress)}%`}
                         </p>
                    )}
                 </div>
            )}
        </div>
    );
};
